import type { TableColumns } from '@ohpen/enso-ui';

import type { CustomFieldType } from '@config/interfaces';
import type { CustomFieldRow } from './interfaces';

export const ENTITY_LIST_NAME = 'customFieldEntities';
export const TYPE_LIST_NAME = 'customFieldTypes';

/** Every type the platform will support, so the filter reads the same before they arrive. */
export const CUSTOM_FIELD_TYPES: CustomFieldType[] = ['text', 'number', 'boolean', 'date', 'valueList'];

export const customFieldColumns: TableColumns<CustomFieldRow> = [
  {
    title: 'config.columns.entity',
    dataIndex: 'entity',
    key: 'entity',
    width: 240,
    options: {
      filter: 'select',
      listName: ENTITY_LIST_NAME,
      format: { type: 'valueList' },
      sorter: true,
      filterOptions: { allowedModes: ['anyMatches'] },
    },
  },
  {
    title: 'config.columns.code',
    dataIndex: 'code',
    key: 'code',
    width: 320,
    options: { filter: 'search', sorter: true, filterOptions: { allowedModes: ['contains'] } },
  },
  {
    title: 'config.columns.label',
    dataIndex: 'name',
    key: 'name',
    options: { filter: 'search', filterOptions: { allowedModes: ['contains'] } },
  },
  {
    title: 'config.columns.type',
    dataIndex: 'type',
    key: 'type',
    width: 180,
    options: {
      filter: 'select',
      listName: TYPE_LIST_NAME,
      format: { type: 'valueList' },
      sorter: true,
      filterOptions: { allowedModes: ['anyMatches'] },
    },
  },
];
